module.exports = __webpack_public_path__ + "480ba744ad946b450850b9f6716d533d.pdf";